interface PromptSelectProps {
  options: { id: string; label: string }[];
  selectedOption?: string;
  onSelectOption: (id: string) => void;
}

export function PromptSelect({
  options,
  selectedOption,
  onSelectOption,
}: PromptSelectProps) {
  return (
    <select
      value={selectedOption}
      onChange={(e) => {
        e.stopPropagation();
        onSelectOption(e.target.value);
      }}
      onClick={(e) => e.stopPropagation()}
      className="px-2 py-1 text-sm border border-gray-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-purple-500"
      style={{ height: '38px', width: '100%', textOverflow: 'ellipsis' }}
    >
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
